"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleep = exports.getScrollbarWidth = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var once_1 = tslib_1.__importDefault(require("lodash/once"));
function getScrollbarWidthBody() {
    var _a;
    var outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.width = "100px";
    document.body.appendChild(outer);
    var widthNoScroll = outer.offsetWidth;
    // force scrollbars
    outer.style.overflow = "scroll";
    // add inner div
    var inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);
    var widthWithScroll = inner.offsetWidth;
    // remove divs
    (_a = outer.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(outer);
    return widthNoScroll - widthWithScroll;
}
/**
 * Returns the current actual scrollbar width.
 * For performance reasons this is memoized as the value is highly unlikely to change
 */
exports.getScrollbarWidth = once_1.default(getScrollbarWidthBody);
function sleep(delay) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) {
                    setTimeout(resolve, delay);
                })];
        });
    });
}
exports.sleep = sleep;
//# sourceMappingURL=utils.js.map